<form [formGroup]="coBuyerForm" (ngSubmit)="submitCoBuyerForm()" autocomplete="off">
  <div class="bg-info-subtle rounded-3 mb-3">
    <div class="row">
      <div class="col-md-12">
        <file-drop
          [fileAcceptedFormat]="'.png,.jpg,.jpeg'"
          [titleMsg]="'Upload card to scan'"
          [buttonText]="'Drag and Drop or'"
          (onFileDrop)="onCardFileDrop($event)"
        ></file-drop>
        @if (cardImage()) {
          <div class="d-flex align-items-center gap-2 my-2">
            <i class="bi bi-file-earmark-image fs-18 text-primary"></i>
            <span class="fw-500">
              {{ cardImage()?.file?.name || 'File selected' }}
            </span>
          </div>
        } @else {
          <div class="d-flex flex-column d-md-none">
            <h4 class="text-center text-gray-400">or</h4>
            <div class="d-flex justify-content-center mb-3">
              <button type="button" (click)="captureCard.click()" class="btn btn-dark btn-h42">
                <i class="bi bi-camera fs-16"></i> Take Picture
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="divider d-flex align-items-center fs-14">
    <span class="px-3">or enter manually</span>
  </div>

  <h4 class="mb-2">
    <i class="bi bi-person text-primary me-2"></i>
    Basic Information
  </h4>

  <hr class="mt-0 border-dark-subtle" />

  <div class="row gy-3">
    <div class="col-xl-4 col-sm-6">
      <generic-dropdown
        [items]="titlesList()"
        [label]="'Title'"
        [placeholder]="'Select Title'"
        formControlName="title"
      ></generic-dropdown>
    </div>
    <div class="col-xl-4 col-sm-6">
      <input-field
        [label]="'First Name'"
        [type]="'text'"
        [placeholder]="'Enter First Name'"
        formControlName="firstName"
        [requiredLabel]="true"
        [required]="true"
        [errormessage]="'First Name is required'"
      ></input-field>
    </div>
    <div class="col-xl-4 col-sm-6">
      <input-field
        [label]="'Middle Name'"
        [type]="'text'"
        [placeholder]="'Enter Middle Name'"
        formControlName="middleName"
      ></input-field>
    </div>
    <div class="col-xl-4 col-sm-6">
      <input-field
        [label]="'Last Name'"
        [type]="'text'"
        [placeholder]="'Enter Last Name'"
        formControlName="lastName"
        [requiredLabel]="true"
        [required]="true"
        [errormessage]="'Last Name is required'"
      ></input-field>
    </div>
    <div class="col-xl-4 col-sm-6">
      <input-field
        [label]="'Email'"
        [type]="'email'"
        [placeholder]="'Enter Email'"
        formControlName="email"
        [requiredLabel]="true"
        [required]="true"
        [errormessage]="'Email is required'"
      ></input-field>
      @if (
        coBuyerForm.get('email')?.hasError('email') &&
        (coBuyerForm.get('email')?.touched || coBuyerForm.get('email')?.dirty)
      ) {
        <div class="text-danger">Please enter a valid email address</div>
      }
    </div>
    <div class="col-xl-4 col-sm-6">
      <input-field
        [label]="'SIN/SSN'"
        [type]="'text'"
        [placeholder]="'Enter SIN/SSN'"
        formControlName="ssn"
      ></input-field>
    </div>
    <div class="col-xl-4 col-sm-6">
      <label class="form-label d-block">Date of Birth</label>
      <p-datepicker
        placeholder="Date of Birth"
        [showClear]="true"
        [showIcon]="true"
        [iconDisplay]="'input'"
        [dateFormat]="'yy-mm-dd'"
        [maxDate]="maxDate"
        formControlName="dateOfBirth"
        styleClass="w-100"
      ></p-datepicker>
    </div>
    <div class="col-auto align-self-end">
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" id="addToMailingList" formControlName="addToMailingList" />
        <label class="form-check-label" for="addToMailingList">Add to Mailing List</label>
      </div>
    </div>
    <div class="col-auto align-self-end">
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" id="includeInContract" formControlName="includeInContract" />
        <label class="form-check-label" for="includeInContract">Include in Contract</label>
      </div>
    </div>
    <div class="col-auto align-self-end">
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" id="isActive" formControlName="isActive" />
        <label class="form-check-label" for="isActive">Is Active</label>
      </div>
    </div>

    <div class="col-12">
      <div class="d-flex align-items-center gap-3 pb-1">
        <h4 class="mb-0">
          <i class="bi bi-geo-alt text-primary me-2"></i>
          Address
        </h4>
        <button class="btn btn-primary px-3 py-1" type="button" (click)="copyProspectDetails()">
          Copy Prospect's Address
        </button>
      </div>

      <hr class="mt-0 border-dark-subtle" />
    </div>
  </div>
  <ng-container formGroupName="address">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <input-field
          [label]="'Address Line 1'"
          [type]="'text'"
          [placeholder]="'Enter Address Line 1'"
          formControlName="addressLine1"
          [requiredLabel]="true"
          [required]="true"
          [errormessage]="'Address Line 1 is required'"
        ></input-field>
      </div>
      <div class="col-lg-12 col-md-12">
        <input-field
          [label]="'Address Line 2'"
          [type]="'text'"
          [placeholder]="'Enter Address Line 2'"
          formControlName="addressLine2"
        ></input-field>
      </div>
      <!-- <div class="col-lg-3 col-md-6">
        <input-field
          [label]="'Suite'"
          [type]="'text'"
          [placeholder]="'Enter Suite'"
          formControlName="suite"
        ></input-field>
      </div> -->
      <div class="col-lg-3 col-md-6">
        <input-field
          [label]="'Post Code/ZIP Code'"
          [type]="'text'"
          [placeholder]="'Enter Post Code/ZIP Code'"
          formControlName="postalCode"
          [requiredLabel]="true"
          [required]="true"
          [errormessage]="'Post Code/ZIP Code is required'"
        ></input-field>
      </div>
      <div class="col-lg-3 col-md-6">
        <generic-dropdown
          [items]="citiesDisplayList()"
          [label]="'City'"
          [allowSearch]="true"
          [clearable]="true"
          [placeholder]="'Select'"
          formControlName="cityId"
          [required]="true"
          [errormessage]="'City is required'"
        ></generic-dropdown>
      </div>
    </div>
  </ng-container>

  <div class="row mt-3">
    <div class="col-12">
      <h4 class="mb-2">
        <i class="bi bi-phone text-primary me-2"></i>
        Contact Details
      </h4>

      <hr class="mt-0 border-dark-subtle" />
      <div class="row">
        <div class="col-md-6 col-sm-6">
          <phone-number-field formControlName="phone"></phone-number-field>
          @if (coBuyerForm.get('phone')?.value?.length === 0) {
            <div class="text-danger">Phone is required</div>
          }
          @if (
            coBuyerForm.get('phone')?.hasError('required') &&
            (coBuyerForm.get('phone')?.touched || coBuyerForm.get('phone')?.dirty)
          ) {
            <div class="text-danger">Phone is required</div>
          }
        </div>
      </div>
    </div>
  </div>
</form>

<p-confirmdialog />

<input
  #captureCard
  type="file"
  capture="environment"
  accept="image/*"
  (change)="onCardFileChange($event)"
  class="d-none"
/>
